<template>
    <div id="broadcast-requests">
        <AppBreadCrumb :paths="[{ title: $t('wp.whatsapp') }]" :select="true">
            <a-button
                class="actionButtonBreadcrumb"
                @click="unsubscribe"
                type="danger"
                v-if="initialized && status.purchased"
            >
                {{ $t("wp.unsubscribe") }}
            </a-button>
        </AppBreadCrumb>
        <div style="background-color: #ffffff" class="d-flex">
            <div class="side-menubar-wrapper">
                <WhatsappMenu selected-page="broadcast" selected-sub-page="message-templates" />
            </div>

            <div class="main-content">
                <ComingSoonWrapper />
            </div>
        </div>
    </div>
</template>

<script>
import AppBreadCrumb from "../../../../../components/common/AppBreadCrumb";
import WhatsappMenu from "../../components/WhatsappMenu";
import "../../whatsapp.scss";
import { mapGetters, mapState } from "vuex";
import { updateIntegration } from "../../../../../api/billing";
import { sendSocketMessage } from "../../../../../utils/socketStream";
import ComingSoonWrapper from "../../../Chatbot/pages/reports/ComingSoonWrapper";

export default {
    name: "MessageTemplates",
    components: { AppBreadCrumb, WhatsappMenu, ComingSoonWrapper },
    computed: {
        ...mapGetters({
            isHealthy: "whatsapp/isHealthy",
        }),
        ...mapState({
            siteId: (state) => state.site.site._id,
            initialized: (state) => state.whatsapp.info.initialized,
            status: (state) => state.whatsapp.info.status,
        }),
    },
    methods: {
        async unsubscribe() {
            const self = this;
            this.$confirm({
                title: this.$t("wp.cancelWpInetgration"),
                content: this.$t("wp.terminatelWpInetgration"),
                okText: this.$t("wp.unsubscribeWpInetgration"),
                okType: "danger",
                cancelText: this.$t("wp.wpBack"),
                width: 600,
                height: 600,
                async onOk() {
                    await updateIntegration(self.siteId, "whatsapp", false);
                    self.getSettings();
                    sendSocketMessage("user settings-updated", {
                        siteId: self.siteId,
                    });
                    self.showWizard = false;
                    localStorage.removeItem("wp-agreement-accepted");
                    self.changePurchaseStatus(false);
                    sendSocketMessage("whatsapp unsubscribe", {
                        siteId: self.siteId,
                    });
                },
                onCancel() {},
            });
        },
    },
};
</script>

<style scoped></style>
